<template>
  <div class="c-teamwork">
    <h3 class='title_h3 relative'>
      <span>{{ text.title }}</span>
      <div class="textBgCenter absolute" style='top: -50%'></div>
    </h3>
    <p class='l-margin-bottom-20'>{{ text.teamworkContent }}</p>

    <div class="c-teamwork__item" v-for="(item, index) in content" :key='index'>
      <div class="c-teamwork__item--image" :style="{backgroundImage:'url('+ item.bgUrl +')'}">
        <div class="c-teamwork__shadow" :style="{backgroundColor: item.shadowColor }">
          <img :src="item.url" alt="">
        </div>
      </div>
      <div class="c-teamwork__item--content" :style="{backgroundColor: item.bgColor }">
        <div class="c-teamwork__item--text">
          <h3 class='title_h3' :style="{color: item.color }">{{ item.title }}</h3>
          <p :style="{color: item.contentColor }">{{ item.content }}</p>
        </div>
      </div>
    </div>

    <div class="c-teamwork__own">
      <h3 class='title_h3'>{{ text.ownTitle }}</h3>
      <div class="c-teamwork__own--partners">
        <div class="c-teamwork__own--partner" v-for="(item, index) in text.partner" :key="index">
          <img :src="item.url" :alt="item.title">
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'teamWork',
    props: ['content'],
    data(){
      return{
        text:{
          title: this.$t('team_work.title'),
          teamworkContent: '',
          ownTitle: this.$t('team_work.ownTitle'),
          partner: [
            {title: this.$t('team_work.partner1.title'), url: require('../../assets/img/logo_systec_company.png')},
            {title: this.$t('team_work.partner2.title'), url: require('../../assets/img/logo_imv_company.png')},
          ]
        },
      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
